import { useExportBenchmarkingReport } from '../../hooks/useExportBenchmarkingReport'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'
import useToastStore from '@/stores/useToastStore/useToastStore'
import { useTranslation } from 'react-i18next'

export type ExportBenchmarkingReportProps = {
    reportId: string
    onClick?: () => void
}

export const ExportBenchmarkingReport: React.FC<
    ExportBenchmarkingReportProps
> = ({ reportId, onClick }) => {
    const addAlert = useToastStore((state) => state.addAlert)
    const { t } = useTranslation('translations')
    const { exportBenchmarkingReport } = useExportBenchmarkingReport(reportId)

    return (
        <MenuItem
            path="/"
            variant="ghost"
            label={t('common.export_report_dropdown.options.xls')}
            render={({ renderContents }) => (
                <button
                    className="group w-full outline-none"
                    onClick={() => {
                        addAlert({
                            variant: 'success',
                            title: t(
                                'reporting.export_report.success_toast.title'
                            ),
                            description: t(
                                'reporting.export_report.success_toast.description'
                            ),
                        })
                        onClick?.()
                        exportBenchmarkingReport()
                    }}
                    data-testid="export-benchmarking-excel-button"
                >
                    {renderContents()}
                </button>
            )}
        />
    )
}
